// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sunzi__image-load-31bVK {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.sunzi__image-load-31bVK img {\n  max-width: 100%;\n  max-height: 100%;\n}\n.sunzi__image-load-31bVK .sunzi__ripple-1LSgc {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 20px;\n  height: 20px;\n  margin: auto;\n  border-radius: 50%;\n  background: #ff0136;\n  animation: sunzi__ripple-1LSgc 1s 0s ease-in-out infinite;\n}\n.sunzi__image-load-31bVK .sunzi__ripple-hide-YYNY3 {\n  display: none;\n}\n@keyframes sunzi__ripple-1LSgc {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n", ""]);
// Exports
exports.locals = {
	"image-load": "sunzi__image-load-31bVK",
	"imageLoad": "sunzi__image-load-31bVK",
	"ripple": "sunzi__ripple-1LSgc",
	"ripple-hide": "sunzi__ripple-hide-YYNY3",
	"rippleHide": "sunzi__ripple-hide-YYNY3"
};
module.exports = exports;
